import { css } from 'styled-components'

/* Column */

export const column = css`
  display: flex;
  flex-direction: column;
`

export const columnCenterX = css`
  ${column};
  align-items: center;
`

export const columnCenterXY = css`
  ${column};
  align-items: center;
  justify-content: center;
`

export const columnCenterY = css`
  ${column};
  justify-content: center;
`

/* Row */

export const row = css`
  display: flex;
  flex-direction: row;
`

export const rowCenterX = css`
  ${row};
  justify-content: center;
`

export const rowCenterXY = css`
  ${row};
  align-items: center;
  justify-content: center;
`

export const rowCenterY = css`
  ${row};
  align-items: center;
`

/* Text transform */

export const capitalize = css`
  text-transform: uppercase;
`

export const capitalizeFirstLetter = css`
  :first-letter {
    text-transform: uppercase;
  }
`
